const BACKGROUND_GRADIENTS = {
  gradient1: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  gradient2: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  gradient3: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  gradient4: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  gradient5: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  gradient6: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
  gradient7: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
  gradient8: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
  gradient9: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
  gradient10: 'linear-gradient(135deg, #232931 0%, #2193b0 100%)',
};

export function getBackgroundGradient(gradientId) {
  return BACKGROUND_GRADIENTS[gradientId] || BACKGROUND_GRADIENTS.gradient10;
}

/**
 * Заливка контейнера приветствия. Для типа image не используем url() в CSS —
 * фото выводится отдельным <img> (object-fit: cover).
 */
export function welcomeScreenFillStyle(settings) {
  if (!settings) {
    return { background: getBackgroundGradient('gradient10') };
  }
  const t = settings.welcomeScreenBackgroundType || 'gradient';
  if (t === 'image' && settings.welcomeScreenBackgroundImage) {
    return { background: 'none', backgroundColor: '#0f172a' };
  }
  if (t === 'solid') {
    return { background: settings.welcomeScreenBackgroundColor || '#0f172a' };
  }
  return { background: getBackgroundGradient(settings.welcomeScreenBackgroundGradient || 'gradient10') };
}
